export class ProdutoEspecialCliente {
  public idprodutoespecialcliente: number;
  public idprodutotabelaespecial: number;
  public idcliente: number;
  public datainclusao: Date;
  public name: string;

  constructor() { }
}
